import Cookies from 'js-cookie'

function merge<T> (left: T, right: Partial<T>): T {
  const obj: any = {}
  Object.keys(left).forEach(key => {
    obj[key] = (right[key] || left[key]) + ''
  })
  return obj
}

function send<T> (info: T): void {
  // const reportUrl = 'http://111.230.84.242/g/v1/?'
  const reportUrl = 'https://helpduba1.ksmobile.com/g/v1/?'
  let img = new Image(0, 0)
  img.onload = function () {
    img = null
  }
  img.src = reportUrl + new URLSearchParams(info as any).toString()
  if (img.complete) {
    img = null
  }
}

// eslint-disable-next-line no-magic-numbers
function randomString (length = 32) {
  const charMap = '0123456789abcdef'
  const mapLength = charMap.length
  let result = ''
  for (let i = 0; i < length; i++) {
    result += charMap.charAt(Math.floor(Math.random() * mapLength))
  }
  return result
}

function getUuid () {
  const anonymousUuidKey = 'anonymous_uuid'
  let uuid
  let user
  try {
    user = JSON.parse(Cookies.get('userInfo'))
  } catch (error) {
    uuid = localStorage.getItem(anonymousUuidKey)
  }

  if (user?.uid) {
    // eslint-disable-next-line no-magic-numbers
    uuid = user.uid.padStart(32, '0')
  } else {
    if (!uuid) {
      uuid = randomString()
      localStorage.setItem(anonymousUuidKey, uuid)
    }
  }

  return uuid
}

export interface ReportCommonArgs {
  product_no: number,
  public_index: number,
  uuid: string,
  tid1: number,
  tid2: number,
  tod1: number,
  tod2: number,
  type: number,
  tryno: number,
  iid: number,
  collect_time: number,
  lastver: number,
}

const COMMON_CONFIG: ReportCommonArgs = {
  product_no: 1,
  public_index: 1,
  uuid: '',
  tid1: 0,
  tid2: 0,
  tod1: 0,
  tod2: 0,
  type: 0,
  tryno: 0,
  iid: 0,
  collect_time: 0,
  lastver: 0,
}

export function makeReporter<T extends { [key: string]: number | string }> (defaultConfig: T | (() => T), formatter?: (data: T) => T | void) {
  return function reportFn (customConfig: Partial<T>): void {
    if (typeof defaultConfig === 'function') {
      defaultConfig = defaultConfig()
    }
    const baseConfig = Object.assign({}, COMMON_CONFIG, defaultConfig)
    baseConfig.uuid = getUuid()
    const data = merge(baseConfig, customConfig)
    const formattedData = typeof formatter === 'function' ? formatter(data as T) : data
    const SECOND_TIME_STEP = 1000
    // eslint-disable-next-line dot-notation
    formattedData['collect_time'] = (Date.now() / SECOND_TIME_STEP).toFixed(0)
    send(formattedData)
  }
}
